import React from 'react';

const CidadeContext = React.createContext();

export default CidadeContext;
